export const wallpaper_za=[
    {
        id:1,
        category_name:"Fortnite Battle Royale Tips",
        images:[
            {
                id:1,
                title:"#1 How to play Fortnite guide for absolute beginners",
                images_url:"https://cdn.game-lords.com/fortnitebattleroyaletips/1%23+How+to+play+Fortnite+guide+for+absolute+beginners.jpg"
            },
            {
                id:2,
                title:"#2 How to play Fortnite guide for absolute beginners",
                images_url:"https://cdn.game-lords.com/fortnitebattleroyaletips/2%23+How+to+play+Fortnite+guide+for+absolute+beginners.jpg"
            },
            {
                id:3,
                title:"#3 How to play Fortnite guide for absolute beginners",
                images_url:"https://cdn.game-lords.com/fortnitebattleroyaletips/3%23+How+to+play+Fortnite+guide+for+absolute+beginners.jpg"
            },
            {
                id:4,
                title:"#4 How to play Fortnite guide for absolute beginners",
                images_url:"https://cdn.game-lords.com/fortnitebattleroyaletips/4%23+How+to+play+Fortnite+guide+for+absolute+beginners.jpg"
            },
            {
                id:5,
                title:"#5 How to play Fortnite guide for absolute beginners",
                images_url:"https://cdn.game-lords.com/fortnitebattleroyaletips/5%23+How+to+play+Fortnite+guide+for+absolute+beginners.jpg"
            },
            {
                id:6,
                title:"#6 How to play Fortnite guide for absolute beginners",
                images_url:"https://cdn.game-lords.com/fortnitebattleroyaletips/6%23+How+to+play+Fortnite+guide+for+absolute+beginners.jpg"
            },
            {
                id:7,
                title:"#7 How to play Fortnite guide for absolute beginners",
                images_url:"https://cdn.game-lords.com/fortnitebattleroyaletips/7%23+How+to+play+Fortnite+guide+for+absolute+beginners.jpg"
            },
            {
                id:8,
                title:"#8 How to play Fortnite guide for absolute beginners",
                images_url:"https://cdn.game-lords.com/fortnitebattleroyaletips/8%23+How+to+play+Fortnite+guide+for+absolute+beginners.jpg"
            },
        ]
    }
]


// WEBPACK FOOTER //
// ./src/constants/wallpapers_za.js